import { I18nConfig, TranslationResources } from "@spartacus/core";
import { en } from "./en";
import { slbTranslationsChunksConfig } from "./slb-i18n-chunks.config";

export const slbTranslations: TranslationResources = { en };

export const slbTranslationsConfig: I18nConfig = {
  i18n: {
    resources: slbTranslations,
    chunks: slbTranslationsChunksConfig,
    fallbackLang: 'en',
  },
};